// Session duration bounds, shared by every dialog that edits a session length.
// The field itself stays free-text while typing (so a value can be cleared and
// retyped); these helpers decide whether what is in the box may be submitted.
export const MIN_SESSION_MINUTES = 15;
export const MAX_SESSION_MINUTES = 360;

// Accepts the raw TextField value: '' while the box is empty, a number once a
// digit has been typed.
export const isValidSessionDuration = (value) => {
  const minutes = typeof value === 'number' ? value : parseInt(value, 10);
  return Number.isFinite(minutes) && minutes >= MIN_SESSION_MINUTES && minutes <= MAX_SESSION_MINUTES;
};

// Normalises the field value for an onChange handler: keeps '' so the user can
// clear the box, otherwise stores a number.
export const parseDurationInput = (raw) => (raw === '' ? '' : Number(raw));
